import styled from '@emotion/styled'

export const CompactSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SummaryMain = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`

export const SummaryTitle = styled.strong`
  color: #122a41;
`

export const SummaryDescription = styled.div`
  display: -webkit-box;
  overflow: hidden;
  color: #5f6f82;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`

export const SummaryBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

export const SummaryBadge = styled.span`
  border-radius: 999px;
  padding: 2px 8px;
  background: #f4f4f4;
  color: #5f6f82;
  font-size: 12px;
`

export const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

export const EmptyInline = styled.div`
  color: #8fa0b5;
  font-style: italic;
`
